import { render, staticRenderFns } from "./InfoHr.vue?vue&type=template&id=1f5318fa&scoped=true"
import script from "./InfoHr.vue?vue&type=script&lang=js"
export * from "./InfoHr.vue?vue&type=script&lang=js"
import style0 from "./InfoHr.vue?vue&type=style&index=0&id=1f5318fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5318fa",
  null
  
)

export default component.exports